import React from 'react';
import styled from 'styled-components';
import ReactSelect from 'react-select';

import { Form, Field } from 'formik';

import TextField, { TextFieldProps } from '@mui/material/TextField';

import { Styling, Colors } from '../../constants';
import {
  Separator as SeparatorBase,
} from '../Shared';

export const MaterialInputField = styled(TextField)`
  width: 100%;
` as React.ComponentType<TextFieldProps>;

export const FormikForm = styled(Form)`
  display: flex;
`;

export const FormikField = styled(Field)`
  flex-grow: 1;
  border: none;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-grow: 1;
  font-size: 14px;
`;

export const Header = styled.div`
  width: 100%;
  height: 68px;
  flex-grow: 0;
  background-color: #f9f8f8;
  padding: ${Styling.DEFAULT_SPACING}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const HeaderTitle = styled.h2`
  color: black;
  font-size: 18px;
  margin-right: ${Styling.SOCIAL_ICON_SPACING}px;
`;

export const InnerContainer = styled.div`
  min-width: ${Styling.MIN_WIDTH}px;
  padding: ${Styling.DEFAULT_SPACING}px;
  display: flex;
  flex-direction: column;
  background-color: white;
`;

export const ControlContainer = styled.div``;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const FormButtonContainer = styled.div`
  display: flex;
  align-items: center;

  button {
    &:not(:last-child) {
      margin-right: ${Styling.DEFAULT_SPACING}px;
    }
  }
`;

export const SettingsContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: ${Styling.DEFAULT_SPACING}px;
`;

export const SettingsSection = styled.div`
  width: 100%;

  ${ControlContainer}:not(:last-child) {
    margin-bottom: ${Styling.DEFAULT_SPACING_DOUBLED}px;
  }
`;

export const SectionSeparator = styled.div`
  margin-left: ${Styling.DEFAULT_SPACING_DOUBLED}px;
  margin-right: ${Styling.DEFAULT_SPACING_DOUBLED}px;
  border-left: ${Colors.PAPER_BORDER};
`;

export const InputContainer = styled.div`
  border: ${Colors.PAPER_BORDER};
  padding: ${Styling.DEFAULT_SPACING_HALVED}px;
  display: flex;
  align-items: center;
  background-color: white;
`;

export const RadioContainer = styled.div`
  padding: ${Styling.DEFAULT_SPACING_HALVED}px;
  display: flex;
  align-items: center;
  flex-grow: 0;
  background-color: white;
`;

export const ControlLabel = styled.div`
  width: 100%;
  font-weight: bold;
  margin-bottom: ${Styling.DEFAULT_SPACING_HALVED}px;
`;

export const Input = styled.input`
  flex-grow: 1;
  border: none;
`;

export const Select = styled.select`
  flex-grow: 1;
  border: none;
`;

export const TextArea = styled.textarea`
  width: 100%;
  resize: vertical;
  border: ${Colors.PAPER_BORDER};
`;

export const RadioButton = styled.input`
  flex-grow: 0;
`;

export const FlexRowContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ErrorLabel = styled.span`
  color: red;
`;

export const Selectable = styled(ReactSelect)`
  &.css-1pcexqc-container {
    &.css-bg1rzq-control {
      border-color: ${Colors.PAPER_BORDER} !important;
    }
  }
`;

export const Separator = (
  <SeparatorBase horizontal={false} color={Colors.BLACK_30} />
);
